import {
  CHANGE_CURRENCY_STATUS_START,
  CHANGE_CURRENCY_STATUS_SUCCESS,
  CHANGE_CURRENCY_STATUS_ERROR,
  SET_BASE_CURRENCY_START,
  SET_BASE_CURRENCY_SUCCESS,
  SET_BASE_CURRENCY_ERROR,
  SET_PAYOUT_CURRENCY_START,
  SET_PAYOUT_CURRENCY_SUCCESS,
  SET_PAYOUT_CURRENCY_ERROR
} from '../../../constants';
import showToaster from '../../../helpers/showToaster';
import getAllCurrencyQuery from './getAllCurrency.graphql';
import { currencyManagement as mutation, getBaseCurrency as subQuery, setBaseCurrencyMutation, updatePayoutCurrencyMutation } from '../../../lib/graphql';

export function updateCurrencyStatus(id, isEnable, symbol) {
  return async (dispatch, getState, { client }) => {
    try {
      dispatch({
        type: CHANGE_CURRENCY_STATUS_START,
      });

      let baseCurrencyId;

      const { data } = await client.query({ query: subQuery, fetchPolicy: 'network-only' });
      if (data?.getBaseCurrency) {
        baseCurrencyId = data.getBaseCurrency.id;
      }

      // Warn admin if he/she try to disable the base currency
      if (baseCurrencyId === id) {
        showToaster({ messageId: 'disableBaseCurrency', toasterType: 'error' })
      } else {
        const { data } = await client.mutate({
          mutation,
          variables: { id, isEnable, symbol },
          refetchQueries: [{ query: getAllCurrencyQuery, variables: { currentPage: 1, searchList: '' } }]
        });

        if (data?.currencyManagement?.status === "success") {
          dispatch({
            type: CHANGE_CURRENCY_STATUS_SUCCESS,
          });
          showToaster({ messageId: 'currencyStatus', toasterType: 'success' })
        } else {
          dispatch({
            type: CHANGE_CURRENCY_STATUS_ERROR,
          });
          showToaster({ messageId: 'commonError', toasterType: 'error', requestContent: data?.currencyManagement?.errorMessage })
        }
      }
    } catch (error) {
      dispatch({
        type: CHANGE_CURRENCY_STATUS_ERROR,
        payload: {
          error
        }
      });
      showToaster({ messageId: 'currencyStatusError', toasterType: 'error' })
      return false;
    }
    return true;
  };
}

export function setBaseCurrency(id) {
  return async (dispatch, getState, { client }) => {
    try {
      dispatch({
        type: SET_BASE_CURRENCY_START,
      });

      const { data } = await client.mutate({
        mutation: setBaseCurrencyMutation,
        variables: { id },
        refetchQueries: [{ query: getAllCurrencyQuery }]
      });

      if (data?.baseCurrency?.status === "success") {
        dispatch({
          type: SET_BASE_CURRENCY_SUCCESS,
        });
        showToaster({ messageId: 'baseCurrency', toasterType: 'success' });
        window.location.reload();
      }

    } catch (error) {
      dispatch({
        type: SET_BASE_CURRENCY_ERROR,
        payload: {
          error
        }
      });
      showToaster({ messageId: 'baseCurrencyError', toasterType: 'error' })
      return false;
    }
    return true;
  };
}

export function updatePayoutCurrency({ id, symbol, isPayoutCurrency }) {

  return async (dispatch, getState, { client }) => {

    dispatch({ type: SET_PAYOUT_CURRENCY_START });

    try {
      const { data } = await client.mutate({
        mutation: updatePayoutCurrencyMutation,
        variables: { id, symbol, isPayoutCurrency }
      });

      if (data?.updatePayoutCurrency?.status == 200) {
        dispatch({ type: SET_PAYOUT_CURRENCY_SUCCESS });
        showToaster({ messageId: 'payoutCurrencySuccess', toasterType: 'success' });
      } else if (data?.updatePayoutCurrency?.status !== 200) {
        dispatch({
          type: SET_PAYOUT_CURRENCY_ERROR,
          payload: {
            error: data?.updatePayoutCurrency?.errorMessage
          }
        });

        showToaster({ messageId: 'failedMessage', toasterType: 'error', requestContent: data?.updatePayoutCurrency?.errorMessage })
        return false;
      }

    } catch (error) {
      dispatch({
        type: SET_PAYOUT_CURRENCY_ERROR,
        payload: { error }
      });
      showToaster({ messageId: 'payoutCurrencyFailed', toasterType: 'error' })
      return false;
    }
    return true;
  }
}